import React, { useState } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import BulkUpdateDialog from '@components-clean/core/bulk-update-dialog/bulk-update-dialog';
import Button from '@components-clean/core/button';
import { SelectedFieldValuesProps } from '@interfaces-clean/bulk-update.interface';
import { useBoolean } from '@hooks/index';

const BulkUpdatePage = () => {
    const showBulkUpdateDialog = useBoolean(false);
    const showResults = useBoolean(false);
    const [selectedFields, setSelectedFields] = useState<SelectedFieldValuesProps[]>([]);

    const validateBulkUpdate = async (data: SelectedFieldValuesProps[]) => {
        setSelectedFields(data);
        showBulkUpdateDialog.setFalse();
        showResults.setTrue();
    };

    const showDialog = () => {
        setSelectedFields([]);
        showResults.setFalse();
        showBulkUpdateDialog.setTrue();
    };

    const observationFields = [
        {
            field: 'active',
            type: 'boolean',
            required: true,
        },
        {
            field: 'justification',
            type: 'text',
            required: false,
            textLimit: 600,
        },
        {
            field: 'responsibleVendors',
            type: 'responsibleVendorLov',
            required: false,
        },
        {
            field: 'edcEntry',
            type: 'edcEntryLov',
            required: false,
        },
        {
            field: 'type',
            type: 'ctqTypeLov',
            required: false,
        },
        {
            field: 'closedDate',
            type: 'date',
            required: false,
        },
        {
            field: 'comments',
            type: 'text',
            required: false,
        },
        {
            field: 'ownerRef',
            type: 'ownerLov',
            required: false,
        },
        {
            field: 'rootCause',
            type: 'text',
            required: false,
        },
        {
            field: 'completedDate',
            type: 'date',
            required: false,
        },
        {
            field: 'dueDate',
            type: 'date',
            required: false,
        },
        {
            field: 'ownerRef',
            type: 'ownerLov',
            required: false,
        },
        {
            field: 'requestedDate',
            type: 'date',
            required: true,
        },
        {
            field: 'resolution',
            type: 'text',
            required: false,
        },
        {
            field: 'responsibleFunction',
            type: 'responsibleFunctionLov',
            required: false,
        },
        {
            field: 'critical',
            type: 'boolean',
            required: true,
        },
        {
            field: 'system',
            type: 'text',
            required: false,
            textLimit: 70,
        },
        {
            field: 'dataSource',
            type: 'text',
            required: false,
            textLimit: 500,
        },
    ];

    return (
        <>
            <div>
                <Button
                    data-testid="Open-Bulk_update"
                    className="k-ml-auto k-h-5 k-mr-0.5"
                    primary
                    onClick={showDialog}
                >
                    {showBulkUpdateDialog.value ? 'Close Bulk Update Dialog' : 'Open Bulk Update Dialog'}
                </Button>
            </div>
            <div>
                {showBulkUpdateDialog.value && (
                    <BulkUpdateDialog
                        studyRef="null"
                        onClose={() => {
                            showBulkUpdateDialog.setFalse();
                        }}
                        onSubmit={validateBulkUpdate}
                        dialogTitle="Bulk Update"
                        warningMessage="You are currently editing 5 records. Updates made in this dialog will overwrite
                        existing details for all selected records."
                        fields={observationFields}
                        unsavedChangesArea="general"
                    />
                )}
            </div>
            {showResults.value && (
                <div style={{ margin: '5px', width: '50%' }}>
                    <Grid data={selectedFields}>
                        <GridColumn field="field" title="Field" />
                        <GridColumn field="type" title="Type" />
                        <GridColumn field="value" title="Value" />
                    </Grid>
                </div>
            )}
        </>
    );
};

export default BulkUpdatePage;
